import QuizLabelParameter from '@components/text/QuizLabelParameter'
import { Box, Flex, MantineStyleProps, Text } from '@mantine/core'
import { IQuizLabelParameter } from '@components/text/QuizLabelParameter'
import React from 'react'

interface IQuizParameterTemplate {
    children?: React.ReactNode
    label?: IQuizLabelParameter['label']
    description?: IQuizLabelParameter['description']
    required?: IQuizLabelParameter['required']
    type?: 'parameter' | 'value' | 'conclude' | 'input'
    afterLabel?: string
    bg?: MantineStyleProps['bg']
}

const QuizParameterTemplate = ({
    children,
    label = '',
    description,
    required,
    type = 'parameter',
    afterLabel = '',
    bg = 'none',
}: IQuizParameterTemplate) => {
    return (
        <Flex
            style={{ borderRadius: '16px' }}
            ml={{ xs: '0', lg: type !== 'conclude' ? 'lg' : '0' }}
            p={type === 'conclude' ? 'lg' : ''}
            pr={0}
            bg={type === 'conclude' ? 'fuchasia.4' : bg}
            justify={{ xs: 'start', md: 'space-between' }}
            align={{ lg: 'center' }}
            direction={{ xs: 'column', md: 'row' }}
        >
            <QuizLabelParameter
                c={type === 'conclude' ? 'text.0' : 'text.2'}
                fw={type === 'conclude' ? 'bold' : 'normal'}
                {...{ label, description, required }}
            />
            <Flex gap='md' align='flex-start'>
                {type === 'value' && (
                    <Text c='fuchasia.4' pt={4} pr='11px'>
                        {children}
                    </Text>
                )}

                {type === 'conclude' && (
                    <Text c='text.0' fw='bold' pt={4} pr='11px'>
                        {children}
                    </Text>
                )}
                {type === 'parameter' && children}

                <Box
                    w={66}
                    pt={4}
                    c={type === 'conclude' ? 'text.0' : 'text.2'}
                    fw={type === 'conclude' ? 'bold' : 'normal'}
                >
                    {afterLabel}
                </Box>
            </Flex>
        </Flex>
    )
}

export default QuizParameterTemplate
